import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Redirect } from "react-router";
import { Trans, withTranslation } from 'react-i18next';
import Header from "../Parts/Header";
import SubHeader from "../Parts/SubHeader";
import {toast} from "react-toastify";
import Loading from "../Parts/Loading";

class ContactsSec extends Component {
    UNIQUENESS_VALIDATION_ERRORS = [
        'EMAIL_ALREADY_EXISTS',
        'CLIENT_EMAIL_NOT_UNIQUE',
        'CLIENT_PHONE_NOT_UNIQUE',
        'CLIENT_EMAIL_AND_PHONE_NOT_UNIQUE',
    ];
    constructor(props){
        super(props);

        this.formSubmit = this.formSubmit.bind(this);

        this.state = {
            disabled: true,
            step_count: 3,
            current_step: 1,
            redirectToNextStep : false
        };
        this.renderForm = this.renderForm.bind(this);
        this.handleAgreementChange = this.handleAgreementChange.bind(this);
    }

    handleAgreementChange(changeEvent) {
        this.setState({disabled: !changeEvent.target.checked})
    }

    renderForm(props) {
        return ( <Fragment>
                <Form className="form form-layout mt-5">
                    <div className="container form-layout__2-col">
                        <div className="form-group  col-md-6 col-lg-6">
                            <label className="form-label" htmlFor="first_name">{ this.props.t('forms.first_name')}</label>
                            <Field type="text" name="first_name" id="first_name"
                                   className={'form-control' + (props.errors.first_name && props.touched.first_name ? ' is-invalid' : '')}/>
                            <ErrorMessage name="first_name" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label className="form-label" htmlFor="last_name">{ this.props.t('forms.last_name')}</label>
                            <Field type="text" name="last_name" id="last_name"
                                   className={'form-control' + (props.errors.last_name && props.touched.last_name ? ' is-invalid' : '')}/>
                            <ErrorMessage name="last_name" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label className="form-label"
                                   htmlFor="personal_code">{this.props.t('forms.personal_code')}</label>
                            <Field type="text" name="personal_code" id="personal_code"
                                   className={'form-control' + (props.errors.personal_code && props.touched.personal_code ? ' is-invalid' : '')}/>
                            <ErrorMessage name="personal_code" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label className="form-label" htmlFor="email">{ this.props.t('forms.email')}</label>
                            <Field type="text" name="email" id="email" autoComplete="email"
                                   className={'form-control' + (props.errors.email && props.touched.email ? ' is-invalid' : '')}/>
                            <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group col-md-6 col-lg-6">
                            <label htmlFor="phone">{ this.props.t('forms.phone')}</label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">+370</div>
                                </div>
                                <Field type="text"
                                       name="phone"
                                       id="phone"
                                       className={'form-control' + (props.errors.phone && props.touched.phone ? ' is-invalid' : '')
                                       }/>
                            </div>
                            <ErrorMessage name="phone" component="div" className="invalid-feedback definitely-show"/>
                        </div>

                        <div className="form-group col-12">
                            <div className="custom-control custom-checkbox mt-3">
                                <input type="checkbox"
                                       id="customCheck1"
                                       className="custom-control-input"
                                       onChange={this.handleAgreementChange}
                                       checked={! this.state.disabled} />
                                <label className="custom-control-label" htmlFor="customCheck1">
                                    <Trans i18nKey="forms.agreement">
                                        Sutinku su <a href="https://inbank.lt/documents/inbank/lt/lt/pdf/Principles_of_processing_client_data.pdf" target="_blank">Kliento duomenų tvarkymo principais</a> ir <a href="https://inbank.lt/documents/inbank/lt/lt/pdf/Terms_and_Conditions_of_Website_Use.pdf" target="_blank">svetainės naudojimosi taisyklėmis</a>
                                    </Trans>
                                </label>
                            </div>
                            {props.status && props.status.msg && <div>{props.status.msg}</div>}
                        </div>
                    </div>

                    <div className="form-group col-12 d-flex justify-content-center mt-3">
                        <button type="submit" className="btn btn-primary btn-lg" disabled={props.isSubmitting || this.state.disabled}>
                            { this.props.t('forms.next')}
                        </button>
                    </div>
                </Form>
            </Fragment>
        );
    }

    formSubmit(values, actions)
    {
        axios.post('/api/process/'+this.props.application_token+'/contacts_sec', values)
            .then(
                data => {
                    actions.setSubmitting(false);
                    if(data.data.status === 'success') {
                        this.setState({redirectToNextStep : true});
                    }
                },
                error => {
                    let response_data = error.response.data;
                    if (response_data.error_type === 'APPL_ERROR'
                        && !this.UNIQUENESS_VALIDATION_ERRORS.includes(response_data.error_code)) {
                        toast.error(response_data.message);
                        //actions.setStatus({msg: response_data.message })
                    }
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    render() {
        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={'/'+this.props.application_token+'/process/consent_sec'} />
        }

        return (
            <div>
                <Header title={this.props.t('step.registration')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.contacts')}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>

                        <div className="row">
                            { this.props.suggestion.loading ?
                                <div className="form-layout mt-5">
                                    <Loading/>
                                </div>
                                :
                                <Fragment>
                                    <Formik
                                        initialValues={this.props.data}
                                        render={this.renderForm}
                                        onSubmit={this.formSubmit}
                                        enableReinitialize={true}
                                        handleReset={(values, formikBag) => {console.log(values, formikBag)}}
                                    />
                                </Fragment>
                            }
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default withTranslation()(ContactsSec);
